import { debounce, initial, method } from "lodash";
import useRead from "../../useRead";
import toast from "react-hot-toast";
import { useState } from "react";

const useGetSalaryComponents = () => {
  const { list, setGetListParams } = useRead({
    url: "salary-components/list",
    initialData: {
      limit: 10,
      pageNo: 0,
    },
    method: "GET",
    onSuccess: () => {},
    onError: (error) => {
      toast.error("Error fetching salary components:" + error?.message);
    },
  });
  const componentsList = list.data?.component_data || [];
  const pagination = list.data?.pagination || {};
  const isListLoading = list.isLoading;

  const handlePageClick = (val) => {
    setGetListParams((prev) => ({
      ...prev,
      pageNo: val.selected,
    }));
  };

  const onCalculationTypeFilterChange = (value) => {
    setGetListParams((prev) => ({
      ...prev,
      calculation_type: value,
    }));
  };

  const [searchQuery, setSearchQuery] = useState("");

  const onSearch = debounce((searchQuery) => {
    onSearchFn(searchQuery);
  }, 750);

  const onSearchFn = (searchQuery) => {
    setSearchQuery(searchQuery);
    setGetListParams((prev) => ({
      ...prev,
      search: searchQuery,
    }));
  };

  return {
    searchQuery,
    isListLoading,
    componentsList,
    pagination,
    handlePageClick,
    onCalculationTypeFilterChange,
    onSearch,
  };
};

export default useGetSalaryComponents;
